import script from "./QuestionEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionEditor.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionEditor.vue?vue&type=style&index=0&id=08cd4ca8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08cd4ca8"]])

export default __exports__